import request from '../../../axios';

export const patchSponsor = async (
  payload: PostSponsorPayload,
  guid: string,
) => {
  const data = await request.patch(
    `/api/v2/notification/sponsor/${guid}`,
    payload,
  );
  return data;
};
